import type { MaImage } from '@/lib/zybooks-api';

export function getImageNameFromKey(key: string): string {
    if (!key) return '';
    const parts = key.split('/');
    return parts[parts.length - 1];
}

export function getImageNameFromMetadata(metadata: Record<string, string>): string {
    return metadata.filename ?? '';
}

export function getImageNameFromKeyAndMetadata(key: string, metadata: Record<string, string>): string {
    return metadata.filename ?? getImageNameFromKey(key);
}

export function getMaImageUrl(image: MaImage): string {
    return `${import.meta.env.VITE_IMAGE_URL}${image.s3_key}`;
}
